import { useState } from "react";
import axios from "axios";

// Submit form using Axios
const submitContactForm = async (formData) => {
  const updatedFormData = {
    Name: formData.name,
    Email: formData.email,
    Phone: formData.phoneNo,
    Subject: formData.subject,
    Message: formData.message,
    Status: "Not Checked yet",
  };

  const payload = {
    email: formData.email, // dynamically assigned
    name: formData.name,
    subject: formData.subject,
    phoneNo: formData.phoneNo,
    message: formData.message,
  };

  try {
    const response = await fetch(
      "https://mallabhumprayas.org/m-api/contactus",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const result = await response.json();

    if (response.ok) {
      if (result.success) {
        console.log("✅ Form submitted successfully!");
      } else {
        console.error("API error:", result);
      }
    } else {
      console.error("API error:", result);
    }
  } catch (error) {
    alert("🚨 Network error. Please try again later.");
    console.error("Fetch error:", error);
  }

  const response = await axios.post(
    "https://script.google.com/macros/s/AKfycbwpIOdHkYDk8BHgVgJSycPm9XqK18xgGT6BuZY7RnkKpABn5nNPjitYYuY44e52AaL_sA/exec",
    updatedFormData,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );

  return response.data;
};

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNo: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setIsError(false);
    setIsSuccess(false);

    try {
      await submitContactForm(formData);
      setIsSuccess(true);
      setFormData({
        name: "",
        phoneNo: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (err) {
      setIsError(true);
      setError(err);
      console.error("Form submission error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="col-lg-8">
      <form onSubmit={handleSubmit} role="form" className="php-email-form">
        <div className="row">
          <div className="col-md-6 form-group">
            <input
              type="text"
              name="name"
              className="form-control"
              id="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6 form-group mt-3 mt-md-0">
            <input
              type="tel"
              className="form-control"
              name="phoneNo"
              id="phoneNo"
              placeholder="Phone No"
              value={formData.phoneNo}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="form-group mt-3">
          <input
            type="email"
            className="form-control"
            name="email"
            id="email"
            placeholder="Email Id"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group mt-3">
          <input
            type="text"
            className="form-control"
            name="subject"
            id="subject"
            placeholder="Subject"
            value={formData.subject}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group mt-3">
          <textarea
            className="form-control"
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
        </div>
        <div className="my-3">
          {isLoading && <div className="info-item d-flex">Submitting...</div>}
          {isError && (
            <div className="info-item d-flex">
              {error.response?.data?.message || (
                <p style={{ color: "red" }}>
                  Failed to submit form. Please try again.
                </p>
              )}
            </div>
          )}
          {isSuccess && (
            <div className="form-control">
              <p style={{ color: "green" }}>
                Your message has been sent. Thank you!
              </p>
            </div>
          )}
        </div>
        <div className="text-center">
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Sending..." : "Send Message"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
